import gql from 'graphql-tag';

export default gql`
    query GetBoxes($jobId: Int) {
        getBoxes(jobId: $jobId) {
            boxDetails {
                boxId
                boxDesc
                proppantColor
                stageSheetId
                stageSheetColor
                weight
                weightRemaining
                currentProppantWeight
                loadId
                doNotUse
                row
                rowId
                column
                columnId
                level
                proppantId
                proppantDesc
                stageSheetProppantId
                queueDesc
                fillPerc
                loadWeight
                sandTicket
                stageSheetBellyDump {
                    sandTicket
                    sandTicketWeight
                    sandTicketWeightRemaining
                    loadId
                    allocatedWt
                    remainingWt
                }
            }
            stageSheetColors {
                index
                descrip
                color
            }
            proppantColors {
                index
                descrip
                color
            }
            boxStats {
                queueDescrip
                proppantDescrip
                weight
                boxCount
            }
            wellName
            isBellyDump
        }
    }
`;
